export enum ServiceType {
  Consultant = 1,
  B2BContractor = 2,
  Project = 3,
}
